import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationOrderBillingsList from "./taxi-corporation-order-billings-list";
import TaxiCorporationOrderBillingsListParams from "./taxi-corporation-order-billings-list-params";

const useTaxiCorporationOrderBillingsList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiCorporationOrderBillingsList>({
      data: [],
      stats: {
        distance: 0,
        sumOfDiscounts: 0,
        amountForChargeHaltings: 0,
        amountForChargeHighways: 0,
        amountForDistance: 0,
        allContributionsAmount: 0,
      },
      totalCount: 0,
    });

  const load = async (
    params: TaxiCorporationOrderBillingsListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiCorporationOrderBillingsList =
        await taxiCorporationService.gerOrderBillingsList(params, signal);

      setData(taxiCorporationOrderBillingsList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiCorporationOrderBillingsList;
